export const WELLNESS_TYPES: Array<string> = [
	'GT03-MASS',
	'GT03-SAUN',
	'GT03-SOLA',
	'GT03-SPAA',
	'ST03-STBA',
];
